import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ToolbarButton} from '../../../models/toolbar-button/toolbar-button';
import {TenantCostDetailsComponent} from './tenant-cost-details.component';


const routes: Routes = [
  {
    path: '',
    component: TenantCostDetailsComponent,
    data: {
      activeLink: ToolbarButton.COST_MGMT
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantCostDetailsRoutingModule {
}
